// Example route file: src/pages/help/HelpRoutes.jsx
import React from "react";
import HelpArticle from "./HelpArticle";
import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { useHelpArticle } from "../../hooks/useHelpArticles";

// Generic slug route so you don't need a component per page.
function HelpArticleRoute() {
    const { slug } = useParams();
    const { article, loading } = useHelpArticle(slug);
    return <HelpArticle article={article} loading={loading} />;
}

export default function HelpRoutes() {
    return (
        <Routes>
            {/* Example: /help/getting-started */}
            <Route path=":slug" element={<HelpArticleRoute />} />

            {/* Optional default */}
            <Route
                path=""
                element={<Navigate to="/help/getting-started" replace />}
            />
        </Routes>
    );
}
